module.exports = __webpack_public_path__ + "static/pazarlama-icerikleri-9a3750b72a92f60c17195891b22b5720.png";